import styled from "styled-components";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Bio } from "../data/constants";

const Main = styled.main`
  width: min(1440px, 100%);
  margin: 0 auto;
  padding: 40px 48px 72px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 640px) {
    padding: 32px 16px 64px;
  }
`;

const Title = styled.h1`
  font-size: clamp(32px, 6vw, 48px);
  line-height: 1.2;
  margin-bottom: 12px;
`;

const Lead = styled.p`
  font-size: clamp(16px, 2.4vw, 18px);
  line-height: 1.7;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 28px;
`;

const Card = styled.section`
  background: ${({ theme }) => theme.card};
  border: 1px solid #ece7f6;
  border-radius: 16px;
  padding: 22px 20px;
  margin-bottom: 16px;
`;

const Heading = styled.h2`
  font-size: 22px;
  margin-bottom: 10px;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: ${({ theme }) => theme.text_secondary};
`;

const List = styled.ul`
  margin: 8px 0 0 18px;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.8;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`;

const Action = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 18px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(225deg, #854ce6 0%, #c026d3 100%);
`;

const Ghost = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 18px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 600;
  color: ${({ theme }) => theme.primary};
  border: 1.5px solid ${({ theme }) => theme.primary};
`;

const AboutPage = () => {
  return (
    <Main>
      <Seo
        title="About Saroj Giri | ICT Graduate and Developer"
        description="Saroj Giri completed a Bachelor of Information Communication Technology at Aadhikavi Bhanubhakta Campus, Damauli. He builds full-stack websites, Android apps, and computer-vision tools."
        path="/about"
      />
      <Title>About Saroj Giri</Title>
      <Lead>
        I am {Bio.name}, an ICT graduate based in {Bio.location}. I finished a
        Bachelor of Information Communication Technology at Aadhikavi Bhanubhakta
        Campus in June 2025, and I now build software I can show.
      </Lead>

      <Card>
        <Heading>Education</Heading>
        <Text>
          Bachelor of Information Communication Technology, Aadhikavi Bhanubhakta
          Campus, Damauli (Oct 2021 – Jun 2025). The degree covered software
          engineering, databases, computer networks, web technologies, and mobile
          development.
        </Text>
        <Text style={{ marginTop: 10 }}>
          Before that I completed Class 12 in Hotel Management and Technology at
          Parashar College, Damauli, with 82.2%.
        </Text>
      </Card>

      <Card>
        <Heading>What I build</Heading>
        <List>
          <li>Full-stack and front-end websites, including Hotel Aagaman and the TDA school site.</li>
          <li>Computer-vision tools: real-time fire detection and a finger-controlled puzzle.</li>
          <li>A CSV and Excel analyzer with Streamlit and Pandas.</li>
          <li>Interfaces in React, plus Android and UI work when the product needs it.</li>
        </List>
      </Card>

      <Actions>
        <Action to="/projects">See projects</Action>
        <Action to="/contact">Contact</Action>
        <Ghost href={Bio.github} target="_blank" rel="noopener noreferrer">
          GitHub
        </Ghost>
        <Ghost href={Bio.linkedin} target="_blank" rel="noopener noreferrer">
          LinkedIn
        </Ghost>
      </Actions>
    </Main>
  );
};

export default AboutPage;
